import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { FETCH_SERVICE_LIST } from 'modules/services';
import { FETCH_SHOP_LIST } from 'modules/shops';
import { ConsultationSectionProps } from 'remotes/consultation-section';
import { State } from 'store/types';
import { unSanitizeLocalization } from 'utils/unsanitize-localiozation';
import '../../../../i18n.config';
import { ConsultationSectionRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

const WithI18 = withSSR()(ConsultationSectionRemote);

registerWidget<State, ConsultationSectionProps>(`${__NAME__}/consultation-section`, state => {
  const store = initWidgetData(state);
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;
  store.dispatch(FETCH_SHOP_LIST.success, state.shops?.shopList ?? undefined);
  store.dispatch(FETCH_SERVICE_LIST.success, state.services?.serviceList ?? undefined);
  const updatedinItialI18nStore = unSanitizeLocalization(initialI18nStore);

  return remoteProps => (
    <WithI18
      initialI18nStore={updatedinItialI18nStore}
      initialLanguage={initialLanguage}
      store={store}
      {...remoteProps}
    />
  );
});
